import { useCallback } from 'react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useRetrySession = () => {
  const { authMachineRef } = useEssentialMachines();

  return useCallback(() => {
    authMachineRef.send({ type: 'RETRY_SESSION' });
  }, [authMachineRef]);
};
